import React, { useState } from "react";
import FormSummaryElements from "@app/components/FormSummary/FormSummaryElements";
import Accordion from "@app/components/Accordion";
import Badge from "@app/components/Badge";
import Button from "@app/components/Button";
import { useFetcher } from "react-router-dom";
import SignsOverlay from "@app/components/SignsOverlay";
import classNames from "classnames";
import {
	DEPLOYMENT_STATE_HINTS,
	DEPLOYMENT_STATE_KEYS,
	getDeploymentState,
	mapDeploymentErrorCount,
} from "@app/utils/confirmationState";
import { filterElements } from "@app/utils/helper";

const FormSummary = ({ values, steps, type, basePath, mode, onSignatureLoaded, className }) => {
	const archiveMode = mode === "ARCHIVE";
	const printMode = mode === "PRINT";

	const fetcher = useFetcher();
	const [showSignsOverlay, setShowSignsOverlay] = useState(false);
	const deploymentState = getDeploymentState(values, steps, type);

	return (
		<div className={classNames("mb-60", className)}>
			<SignsOverlay
				onSave={async (data) => {
					setShowSignsOverlay(false);
					await fetcher.submit(
						{ action: "SAVE", json: JSON.stringify(data), type },
						{
							method: "post",
							encType: "application/x-www-form-urlencoded",
						},
					);
				}}
				fieldsets={steps[steps.length - 1].fieldsets}
				onCancel={() => {
					setShowSignsOverlay(false);
				}}
				show={showSignsOverlay}
				values={values || {}}
				header={steps[steps.length - 1].header}
			/>
			{steps &&
				steps.map((step, stepIndex) => {
					const state = deploymentState[stepIndex];
					const mappedErrors = DEPLOYMENT_STATE_KEYS.reverse().reduce(
						(acc, key) => ({
							...acc,
							...state[key],
						}),
						{},
					);
					const deploymentErrorCount = mapDeploymentErrorCount(state);
					const stateBadges =
						!archiveMode && !printMode
							? DEPLOYMENT_STATE_KEYS.map((key) =>
									deploymentErrorCount[key] > 0 ? (
										<Badge
											key={key}
											state={key}
											dot={false}
											bg="secondary"
											label={deploymentErrorCount[key]}
											hint={DEPLOYMENT_STATE_HINTS[key]}
										/>
									) : null,
								)
							: [];

					return (
						<Accordion
							key={stepIndex}
							headline={stepIndex < steps.length - 1 ? `${stepIndex + 1}. ${step.header}` : step.header}
							actions={[
								...stateBadges,
								!archiveMode && !printMode && stepIndex < steps.length - 1 ? (
									<Button
										key={1}
										type={"quaternary"}
										iconBefore={"edit"}
										href={`${basePath}${stepIndex + 1}`}
										callback={(event) => {
											event.stopPropagation();
										}}
										linkProps={{ state: { summaryLink: true } }}
									/>
								) : null,
								!archiveMode && !printMode && stepIndex === steps.length - 1 ? (
									<Button
										key={1}
										type={"quaternary"}
										iconBefore={"edit"}
										callback={(event) => {
											event.stopPropagation();
											setShowSignsOverlay(true);
										}}
									/>
								) : null,
							]}
							initialOpen={!archiveMode && !printMode && stepIndex === 0}
							showInstant={printMode}
						>
							{step.fieldsets.map((fieldset, index) => {
								return (
									<FormSummaryElements
										key={index}
										headline={fieldset.headline}
										elements={
											fieldset.elements?.filter((element) => filterElements(element, type)) || []
										}
										type={type}
										values={values ?? {}}
										errors={mappedErrors}
										formStepLink={`${basePath}${stepIndex + 1}`}
										archiveMode={archiveMode}
										printMode={printMode}
										onSignatureLoaded={onSignatureLoaded}
									/>
								);
							})}
							{!archiveMode && !printMode && stepIndex < steps.length - 1 && (
								<div className="mt-24 mb-24 d-flex align-items-center justify-content-center">
									<Button
										label={"Bearbeiten"}
										type={"quaternary"}
										href={`${basePath}${stepIndex + 1}`}
										linkProps={{ state: { summaryLink: true } }}
									/>
								</div>
							)}
						</Accordion>
					);
				})}
		</div>
	);
};

FormSummary.propTypes = {};

export default FormSummary;
